// routes
import { PATH_DASHBOARD, PATH_HAM } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/commonComponents/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  dashboard: getIcon('home'), 
  entries: getIcon('clock'),
  settings: getIcon('gearwheel'),
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: '',
    items: [
      {
        title: 'Dashboard',
        path: PATH_HAM.Dashboard,
        icon: ICONS.dashboard
      },
      {
        title: 'Entries',
        path:  PATH_HAM.Entries,
        icon: ICONS.entries
      },
      {
        title: 'Settings',
        path: PATH_HAM.HamSettings,
        icon: ICONS.settings
      },
      {
        title: 'HAM approval',
        path: PATH_HAM.Hamapproval,
        icon: ICONS.settings
      },
      {
        title: 'Order approval',
        path: PATH_HAM.Orderapproval,
        icon: ICONS.settings
      }
    ]
  }
];

export default sidebarConfig;